import docIcon from "../../assets/img/docIcon02.svg";
import useTranslator from "../../hooks/useTranslator";
import { Button, Modal } from "../../components/design";
import styles from "./approvedModal.module.css";

const ApprovedModal = ({
  showPopup,
  setShowApprovalPopup,
  onhandleManualUpload,
  availableClaveDocs,
  handleInitiateClave,
}) => {
  const { _t } = useTranslator();
  return (
    <Modal
      open={!!showPopup}
      onClose={onhandleManualUpload}
      closeLabel={_t("close")}
      align="start"
      title={_t("saveTimeGetApprovedFaster")}
      actions={
        <>
          <Button variant="secondary" size="lg" onClick={onhandleManualUpload}>
            {_t("keepUploadingManually")}
          </Button>
          <Button
            size="lg"
            onClick={() => {
              handleInitiateClave();
              setShowApprovalPopup(false);
            }}
          >
            {_t("getFromClavepin")}
          </Button>
        </>
      }
    >
      <div className={styles.documentList}>
        {availableClaveDocs.map((name) => (
          <div className={styles.documentRow} key={name}>
            <img src={docIcon} alt="" width={18} height={18} />
            <p>{_t(name, "", "fixed")}</p>
          </div>
        ))}
      </div>

      <p className={styles.subtitle}>
        {_t(
          "landlordsPreferToGetTenantDocumentsViaClavepinItHelpsLandlordsToTrustYourProfileAndMakeYourProfileStrongerAmongstOthers"
        )}
      </p>
    </Modal>
  );
};

export default ApprovedModal;
